/**
 * This function binds the fields from the Sitecore component to the FieldParams from dochub Demo Component
 * @param props Component props received from Sitecore
 */
export function bindPropsToComponentFields(props, paramsFields) {
  const fields = props?.fields ? props.fields : props;

  if(fields && paramsFields) {
    for (const key in fields) {
      if (Object.hasOwnProperty.call(paramsFields, key)) {
        const element = paramsFields[key];
        if(typeof fields[key] === 'object' && 'value' in fields[key])
          {
            fields[key].value = element;
          }
        else {
          fields[key] = element;
        }
      }
    }
  }
}
